<div class="tw-overflow-x-auto">
    <table class="tw-w-full tw-text-sm tw-text-left tw-text-gray-700">
      <thead class="tw-border-b tw-font-medium">
        <tr>
          <th class="tw-py-2 tw-px-3 max-md:tw-px-2">Date & Time<sup class="tw-text-alert-800">*</sup></th>
          <th  class="tw-py-2 tw-px-3 max-md:tw-px-2">Shift Title<sup class="tw-text-alert-800">*</sup></th>
          <th  class="tw-py-2 tw-px-3 max-md:tw-px-2 tw-text-center">Volunteers Needed<sup class="tw-text-alert-800">*</sup></th>
          <th class="tw-py-2 tw-px-3 max-md:tw-px-2">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let contact of contacts" class="tw-border">
          <td class="tw-py-2 tw-px-3 max-md:tw-px-2">
            <div class="tw-flex tw-flex-col tw-items-start">
                <div class="tw-font-bold tw-text-sm tw-leading-[22px]">
                    {{contact.eventDate}}
                </div>
                
                <div class="tw-flex tw-items-center tablet:tw-gap-1 tablet:tw-text-sm tw-text-xs tw-font-medium tw-leading-[22px]">
                    <div>
                        {{contact.startTime ? formatTime(contact.startTime) : ''}} {{getStartTimeAPM(contact)}}
                    </div>
                    <div>
                      -
                    </div>
                    <div>
                        {{contact.endTime ? formatTime(contact.endTime):''}} {{getEndTimeAPM(contact)}}
                    </div>
                </div>
            </div>
          </td>
          <td>
            <div [smlTooltip]="contact.shiftTitle" class="tw-text-sm tw-font-medium tw-leading-[22px] tw-py-2 tw-px-3 max-md:tw-px-2 tw-max-w-[200px] tw-truncate">
            {{contact.shiftTitle}}
        </div>
      </td>
          <td  class="tw-py-2 tw-px-3 max-md:tw-px-2 tw-font-bold tw-text-center">{{ contact.quantity || '-' }}</td>
          <td class="tw-py-2 tw-px-3 max-md:tw-px-2">
            <div class="tw-flex tw-items-center tw-gap-1 tw-text-primary-700 tw-cursor-pointer" (click)="editShift(contact)">
                <i-icon [name]="'edit-o'" class="!tw-w-3 !tw-h-3 tablet:!tw-w-4 tablet:!tw-h-4 tw-text-primary-700 tw-cursor-pointer"
                ></i-icon>
                <div class="tw-text-sm tw-font-bold">
                    Edit
                </div>
            </div>
           
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <div class="tw-mt-6 tw-flex tw-items-center tw-justify-end tw-text-primary-700 tw-gap-1"
  (click)="openDrawer()">
    <i-icon [name]="'plus-rounded'" class="!tw-w-3 !tw-h-3 tablet:!tw-w-4 tablet:!tw-h-4 tw-cursor-pointer"
    ></i-icon>
    <button 
    type="button"
      class="tw-text-center tw-text-[14px] tw-font-bold tw-leading-[20px]">
      Add New Shift
    </button>
  </div>

  <sml-drawer
  [drawerType]="'side'"
  [size]="drawerSize ? 'lg' : 'sm'"
  *ngIf="isDrawerOpen"
  (close)="handleClose($event)"
  [drawerConatinerMain]="'!tw-bg-white'"
  [@slideInOut]
>
  <div class="tw-block" header>
    <div class="tw-flex tw-gap-2 tw-justify-between">
      <div class="tw-flex tw-items-center tw-gap-1">
        <button  type="button" (click)="backButton()" *ngIf="drawerSize">
          <i-icon [name]="'arrow-back'" [height]="'tw-h-[18px]'" [width]="'tw-w-[18px]'" class="!tw-block"></i-icon>
        </button>
        <h3 class="text-[#010f12] tw-text-xl tw-font-bold tw-leading-7 tw-mb-1">
           {{isShiftEdit ? 'Edit Shift' : 'Add New Shift' }}
        </h3>
      </div>
     
      <button type="button" (click)="backButton()">
        <i-icon name="close" [height]="'tw-h-6'" [width]="'tw-w-6'"></i-icon>
      </button>
    </div>
    <p class="tw-text-grey-750 tw-text-sm tw-leading-snug">
        {{isShiftEdit ? 'Edit the details of your shift.' : 'Fill out the details of your shift.' }}
    </p>
  </div>

  <div class="" body>
    <div [formGroup]="shiftForm">
      <div class="tw-grid tw-grid-cols-1 tw-gap-6 tw-mt-6">
        <div class="sml-control-group tw-col-span-1">
            <label for="title" class="sml-label"
            >Shift Title
            <sup class="tw-text-alert-800">*</sup></label
          >
          <input
            id="title"
            [ngClass]="{
              'sml-control-error':
                control['shiftTitle'].invalid &&
                (control['shiftTitle'].dirty || control['shiftTitle'].touched)
            }"
            formControlName="shiftTitle"
            placeholder="Enter Title"
            type="text"
            class="sml-control"
            smlPreventLeadingSpace
          />
          <div
            class="sml-form-error"
            *ngIf="
              control['shiftTitle'].invalid &&
              (control['shiftTitle'].dirty || control['shiftTitle'].touched)
            "
          >
            <p
              *ngIf="control['shiftTitle'].errors?.['required'] || control['shiftTitle'].errors?.['whitespace']"
              class="tw-text-alert-800"
            >
              This field is mandatory.
            </p>
          </div>
            
    </div>
    <div class="sml-control-group tw-col-span-1">
      <label for="date" class="sml-label">
        Event Date<sup class="tw-text-alert-800">*</sup>
      </label>
      <div class="tw-relative">
        <div
          (click)="onStartDate()"
          class="tw-sml-border tw-rounded-lg tw-flex tw-items-center tw-gap-2 tw-justify-between tw-py-[14px] tw-px-3"
          [ngClass]="{
            'sml-control-error':
              control['eventDate'].invalid &&
              (control['eventDate'].dirty ||
                control['eventDate'].touched)
          }"
        >
          <div class="tw-flex-1">
            <input
              class="tw-border-none tw-outline-none"
              placeholder="MM/DD/YYYY"
              formControlName="eventDate"
              readonly
            />
          </div>

          <i-icon
            [name]="'calendar'"
            class="tw-text-mercury-600 !tw-w-4 !tw-h-4 tw-cursor-pointer"
          ></i-icon>
        </div>
        <div class="tw-left-0 tw-absolute tw-z-10" *ngIf="showCalendar">
          <sml-range-picker
            (smlClickOutside)="showCalendar = false"
            [hasSingleCalndar]="true"
            [hasSingleDatePicker]="true"
            [daysOfWeek]="['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']"
            [showClearButton]="false"
            [showApplyButton]="false"
            [showSelectedDates]="false"
            [selectedDate]="selectedDate"
            (selectedDateChange)="onDateChange($event)"
            [disablePastDates]="true"
          ></sml-range-picker>
        </div>
        <div
          class="sml-form-error"
          *ngIf="
            control['eventDate'].invalid &&
            (control['eventDate'].dirty ||
              control['eventDate'].touched)
          "
        >
          <p
            *ngIf="control['eventDate'].errors?.['required']"
            class="tw-text-alert-800"
          >
            Event date is required.
          </p>
        </div>

      </div>
    </div>
    <div class="sml-control-group tw-col-span-1 ">
      <label for="event-time" class="sml-label"
        >Event Time <sup class="tw-text-alert-800">*</sup></label
      >
      <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
        <div
          class="tw-sml-border tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-gap-2 tw-px-1 tw-w-full"
        >
          <input
            class="tw-border-none tw-outline-none tw-w-3/4"
            placeholder="hh:mm"
            formControlName="startTime"
            mask="Hh:m0"
            [apm]="true"
            [validation]="false"
            (blur)="fixTimeOnBlur('startTime')"
            [ngClass]="{
              'sml-control-error':
                control['startTime'].invalid &&
                (control['startTime'].dirty ||
                  control['startTime'].touched)
            }"
          />

          <div
            class="tw-flex tw-flex-col tw-items-center tw-text-mercury-600 tw-font-medium tw-text-sm hover:tw-cursor-pointer"
           
          >
            <i-icon
              [name]="'arrow-up-thin'"
              class="!tw-w-4! !tw-h-4"
              (click)="toggleAMPM('start')"
            ></i-icon>

            <div >
              {{ getCurrentStartTimeAPM() }}
            </div>

            <i-icon
              [name]="'arrow-down-thin'"
              class="!tw-w-4 !tw-h-4"
              (click)="toggleAMPM('start')"
            ></i-icon>
          </div>
        </div>

        <!-- End Time -->
        <div
          class="tw-sml-border tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-gap-2 tw-px-1 tw-w-full"
        >
          <input
            class="tw-border-none tw-outline-none tw-w-3/4"
            placeholder="hh:mm"
            formControlName="endTime"
            mask="Hh:m0"
            [apm]="true"
            [validation]="false"
            (blur)="fixTimeOnBlur('endTime')"
            [ngClass]="{
              'sml-control-error':
                control['endTime'].invalid &&
                (control['endTime'].dirty || control['endTime'].touched)
            }"
          />
          <div
            class="tw-flex tw-flex-col tw-items-center tw-text-mercury-600 tw-font-medium tw-text-sm hover:tw-cursor-pointer"
           
          >
            <i-icon
              [name]="'arrow-up-thin'"
              class="!tw-w-4 !tw-h-4"
              (click)="toggleAMPM('end')"
            ></i-icon>

            <div  >
              {{ getCurrentEndTimeAPM() }}
          </div>

            <i-icon
              [name]="'arrow-down-thin'"
              class="!tw-w-4 !tw-h-4"
              (click)="toggleAMPM('end')"
            ></i-icon>
          </div>
        </div>
      </div>
      @if( shiftForm.errors?.['endTimeLessThanStart']){
      <div class="tw-text-alert-800 sml-form-error">
        End time cannot be smaller than Start time
      </div>
      }
      @if( shiftForm.errors?.['endTimeEqualToStart']){
        <div class="tw-text-alert-800 sml-form-error">
          Start time cannot be equal to End Time 
        </div>
        }

      <div
        id="time-validation-error"
        class="tw-text-alert-800 sml-form-error"
        *ngIf="
          ((control['startTime']?.touched ||
            control['startTime']?.dirty) &&
            control['startTime']?.errors) ||
          ((control['endTime']?.touched || control['endTime']?.dirty) &&
            control['endTime']?.errors)
        "
      >
        <ng-container
          *ngIf="
            control['startTime']?.errors || control['endTime']?.errors
          "
        >
        Please enter time in correct format
        </ng-container>
      </div>
      <div
        class="tw-text-alert-800 sml-form-error"
        *ngIf="shiftForm?.errors"
      >
        <ng-container *ngIf="shiftForm?.errors?.['startTimeRequired']">
          Please enter Start time.
        </ng-container>
        <ng-container *ngIf="shiftForm?.errors?.['endTimeRequired']">
          Please enter End time.
        </ng-container>
       
      </div>
    </div>
    <div class="sml-control-group tw-col-span-1">
      <label for="quantity" class="sml-label"
      >Volunteers Needed
      <sup class="tw-text-alert-800">*</sup></label
    >
    <input
      id="quantity"
      [ngClass]="{
        'sml-control-error':
          control['quantity'].invalid &&
          (control['quantity'].dirty || control['quantity'].touched)
      }"
      formControlName="quantity"
      type="number"
      min="0"
      placeholder="Enter quantity"
      class="sml-control"
      smlInputNumber
    />
    <div
      class="sml-form-error"
      *ngIf="
        control['quantity'].invalid &&
        (control['quantity'].dirty || control['quantity'].touched)
      "
    >
      <p
        *ngIf="control['quantity'].errors?.['required'] || control['quantity'].errors?.['whitespace']"
        class="tw-text-alert-800"
      >
        This field is mandatory.
      </p>
      <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
        Quantity cannot be less than 1
      </div>
      <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['quantityTooLow']" class="tw-text-alert-800 sml-form-error">
        {{control['quantity'].errors?.['quantityTooLow']?.message}}
      </div>
    </div>
      
</div>
    
    </div>
  </div>
</div>


  <div footer class="tw-flex tw-flex-row tw-items-center tw-justify-between">
    <div class="tw-flex tw-items-center tw-gap-[2px] tw-text-[#D11A2A] tw-text-sm tw-font-bold tw-cursor-pointer" *ngIf="isShiftEdit" (click)="removeShift()">
      <i-icon [name]="'trash'" class="!tw-w-4 !tw-h-4"></i-icon>
      <div>
        Remove shift
      </div>
    </div>
    <button type="button" smlButton="link" [size]="'sm'" (click)="closeGridButton()" *ngIf="!isShiftEdit && !drawerSize">
      Cancel
    </button>
    <button type="button" [smlButton]="drawerSize ? 'secondary':'primary'" [size]="'sm'" (click)="saveGridButton()" >
      {{isShiftEdit ? 'Save' : 'Add'}}
    </button>
  </div>
</sml-drawer>

<sml-dialog
  #smlModal
  [size]="'md'"
  [hasConfirmationDialog]="true"
  [dialogTitle]="
    deleteShift ? 'Remove This Shift?':
    drawerSize ? 'Close Shift Creation?' :
    'Discard Shift?'
  "
  [dialogTitlePosition]="'center'"
  [dialogHeaderContent]="
  deleteShift ? 'This action will permanently delete the shift. Are you sure you want to continue?':
   'If you close now, your shift details will not be saved.'
"
  [dialogHeaderContentPosition]="'center'"
  [src]="'./assets/images/landing/exclamation.png'"
  [iconPosition]="'center'"
>
  <ng-container footer>
    <div
      class="tw-flex tw-justify-between tw-items-center tw-py-4 tw-px-8 tw-border-t tw-border-solid tw-border-mercury-200"
    >
      <button
        type="button"
        smlButton="link"
        [size]="'sm'"
        [rounded]="'md'"
        (click)="onCloseDialog()"
        class="!tw-pl-0"
      >
        {{deleteShift ? 'No, Keep Shift' : 'No, Continue Editing'}}
      </button>

      <div>
        <button
          type="button"
          smlButton="primary"
          [size]="'sm'"
          [rounded]="'md'"
          (click)="onSaveChanges()"
        >
        {{deleteShift ? 'Yes, Remove Shift' : 'Yes, Discard Shift'}}
        </button>
      </div>
    </div>
  </ng-container>
</sml-dialog>